import { render, staticRenderFns } from "./BrbCurrencyDisplay.vue?vue&type=template&id=364d43a3&"
import script from "./BrbCurrencyDisplay.vue?vue&type=script&lang=js&"
export * from "./BrbCurrencyDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/panel/driver/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('364d43a3')) {
      api.createRecord('364d43a3', component.options)
    } else {
      api.reload('364d43a3', component.options)
    }
    module.hot.accept("./BrbCurrencyDisplay.vue?vue&type=template&id=364d43a3&", function () {
      api.rerender('364d43a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/brb-components/BrbCurrencyDisplay.vue"
export default component.exports